import { render, staticRenderFns } from "./PpeApplyScrapDetailList.vue?vue&type=template&id=265afb5a&"
import script from "./PpeApplyScrapDetailList.vue?vue&type=script&lang=js&"
export * from "./PpeApplyScrapDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports